var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0.75C10.6562 0.75 0.25 11.25 0.25 24C0.25 36.8438 10.6562 47.25 23.5 47.25C36.25 47.25 46.75 36.8438 46.75 24C46.75 11.25 36.25 0.75 23.5 0.75ZM23.5 44.25C12.3438 44.25 3.25 35.25 3.25 24C3.25 12.9375 12.25 3.75 23.5 3.75C34.5625 3.75 43.75 12.8438 43.75 24C43.75 35.1562 34.6562 44.25 23.5 44.25ZM36.7188 18.5625C37.1875 18.0938 37.1875 17.3438 36.7188 16.9688L35.9688 16.125C35.5 15.6562 34.75 15.6562 34.375 16.125L19 31.3125L12.5312 24.8438C12.1562 24.375 11.4062 24.375 10.9375 24.8438L10.1875 25.5938C9.71875 26.0625 9.71875 26.7188 10.1875 27.1875L18.25 35.3438C18.625 35.7188 19.375 35.7188 19.8438 35.3438L36.7188 18.5625Z",
    fill: "#04BE8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic-success.6d9a3cec6bad357472585d6bb5842528.svg";
export { ForwardRef as ReactComponent };